import React, { Component } from "react"
import { Map, GoogleApiWrapper, Marker } from 'google-maps-react';

  const mapStyles = {
    width: '100%',
    height: '100%',
    zIndex: '0',
    boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'
  };

export class MapContainer extends Component {
    constructor(props) {
      super(props);
  
      this.state = {
        stores: [{latitude: 34.047083, longitude: -118.248175},
                {latitude: 33.449392, longitude: -112.080480},
                {latitude: 31.760536, longitude: -106.484561},
                {latitude: 29.425138, longitude: -98.494716},
                {latitude: 29.950527, longitude: -90.075954},
                {latitude: 30.392560, longitude: -86.499820},
                {latitude: 27.949750, longitude: -82.457611},
                {latitude: 29.425138, longitude: -98.494716},
                {latitude: 26.640689, longitude: -81.873025},
                {latitude: 25.771411, longitude: -80.192107},
                {latitude: 24.555010, longitude: -81.780199}]
      }
    }
  
    displayMarkers = () => {
      return this.state.stores.map((store, index) => {
        return <Marker key={index} id={index} position={{
         lat: store.latitude,
         lng: store.longitude
       }}
       onClick={() => console.log("You clicked me!")} />
      })
    }
  
    render() {
      return (
          <Map
            google={this.props.google}
            zoom={5}
            style={mapStyles}
            initialCenter={{ lat: 31.350707, lng: -99.138401}}
          >
            {this.displayMarkers()}
          </Map>
      );
    }
}

export default GoogleApiWrapper({
    apiKey: 'AIzaSyCB51KiL37ubk1i4gy_uZ-yAFFcAcs7rGU'
  })(MapContainer);